import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, TextField, Typography, Button } from '@mui/material';
import { useStyles } from './styles';
import FooterContainer from '../../components/Footer';
import backgroundImg from '../../assets/images/image-1.jpg';
import backgroundImg2x from '../../assets/images/image-1@2x.jpg';
import backgroundImg3x from '../../assets/images/image-1@3x.jpg';

function HomeContainer() {
  const classes = useStyles();
  const [trackingCode, setTrackingCode] = useState('');
  const navigate = useNavigate();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    navigate(`/${trackingCode}`);
  };

  const settings = {
    tracking_show_axlehire_support_phone: 'false',
    tracking_show_axlehire_support_email: 'true',
    axlehire_support_phone_number: '+18552497447',
    axlehire_support_phone_email: 'support@gojitsu.com',
    tracking_support_email_subject: 'Customer Request Support',
  };

  return (
    <Box sx={classes.root}>
      <Box sx={classes.bodyContainer}>
        <Box component="img" src={backgroundImg} srcSet={`${backgroundImg2x} 2x, ${backgroundImg3x} 3x`} alt="" sx={classes.cover} />
        <Box component="form" onSubmit={handleFormSubmit} sx={classes.mainContainer}>
          <Box sx={classes.mainFormInner}>
            <Typography variant="h1" sx={classes.mainFormTitle}>
              Track your package with us!
            </Typography>
            <Typography variant="h2" sx={classes.mainFormSubTitle}>
              Get your order’s shipping status through Jitsu service
            </Typography>
            <Box sx={classes.formInputWrapper}>
              <TextField
                placeholder="Enter your tracking ID here..."
                sx={classes.formInput}
                color="primary"
                fullWidth
                variant="outlined"
                value={trackingCode}
                onChange={(e) => setTrackingCode(e.target.value)}
              />
              <Button type="submit" size="large" variant="contained" color="primary" sx={classes.submitBtn}>
                Track
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      {(!settings?.hide_footer || settings.hide_footer === 'false') && <FooterContainer client={{}} settings={settings} />}
    </Box>
  );
}

export default HomeContainer;
